import { BlocksIconSuccessFilled } from 'blocks-nextjs/blocks-web-components/components/icon/icons/success-filled';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconSuccessFilled = createComponent({
  react: React,
  tagName: 'cat-icon-success-filled',
  elementClass: BlocksIconSuccessFilled
});
